import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { Athlete, AthleteWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthlete(): UseMutationResult<
  AxiosResponse<Athlete>,
  AxiosError<ErrorMessage>,
  AthleteWrite
> {
  const queryClient = useQueryClient();

  const updateAthlete = useCallback((athlete: AthleteWrite): Promise<AxiosResponse<Athlete>> => {
    return client.put(`athletes/${athlete.athleteId}/`, athlete);
  }, []);

  return useMutation(updateAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['linkedProfiles'],
      });
    },
  });
}
